jQuery(document).ready( function($) {
  $(document).on('closed.zf.offcanvas', function(){
    $('#mobile-nav-dropdown').css('display', 'none');
  })

  $('.hero-slider-1').slick({
    arrows: false,
    dots: true,
    autoplay: true,
    pauseOnHover: false,
    autoplaySpeed: 5000
  });

  $('.hero-slider-2').slick({
    arrows: false,
    dots: true,
    autoplay: true,
    pauseOnHover: false,
    autoplaySpeed: 5000
  }).slick('slickPause');

  setTimeout(function() {
    $('.hero-slider-2').slick('slickPlay');
  }, 2500)
})
